export class Context {
    constructor(
    public organisationId: string,
    public businessId: string,
    public venueId: string
    ) { }
}
